import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";

export function PromoBanner() {
  const { t } = useTranslation("polls");

  return (
    <div className="border-t border-white/5 bg-background dark:bg-[#0a0a0a] py-3 px-4">
      <div className="max-w-2xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-xs text-gray-500">
          <Calendar className="w-3.5 h-3.5 text-blue-500 flex-shrink-0" />
          <span>{t("promo_banner_text")}</span>
        </div>
        <Link
          to="/create"
          className="flex items-center gap-1.5 text-xs font-medium text-blue-400 hover:text-blue-300 transition-colors whitespace-nowrap"
        >
          {t("promo_banner_cta")}
          <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
}
